import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 32 32', fill: fillColor, className: className, children: _jsxs("g", { children: [_jsx("path", { d: 'M27.94,28.44h-24a.5.5,0,0,1-.5-.5v-24a.5.5,0,0,1,.5-.5h24a.5.5,0,0,1,.5.5v24A.51.51,0,0,1,27.94,28.44Zm-23.5-1h23v-23h-23Z' }), _jsx("path", { d: 'M22,16.49H10a.5.5,0,0,1,0-1H22a.5.5,0,1,1,0,1Z' })] }) }));
});
export default React.memo(Icon);
